module.exports = __webpack_public_path__ + "static/media/8.771e0868.mp3";